import React, { useContext, useState } from 'react';
import ImageUpload from '../../../shared/components/FormElements/imageUpload';
import { useForm } from '../../../shared/hooks/form-hook';
import { MdAttachEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { FaAddressCard } from "react-icons/fa";
import CourseModal from '../../../shared/components/UIElements/courseModal';
import { AuthContext } from '../../../shared/context/auth-context';


import './Admin-profile.css'

const Admin = ({ show, onCancel }) => {
  const auth = useContext(AuthContext);
  const { user, updateUser } = useContext(AuthContext);

  const [isLoaded, setIsLoaded] = useState(false);

  const [ formState, inputHandler ] = useForm(
    { 
      image: {
        value: null,
        isValid: false
      }
    },
    false
  );

  
    
  const fullName = auth.user.name;
  const [firstName, lastName] = fullName.split(" ");

  const role = auth.user.role;
  const Role = role.charAt(0).toUpperCase() + role.slice(1);


  const uploadImageFile = async (event) => {
    event.preventDefault();

    const isConfirmed = window.confirm("Are you sure to change it?");

    if(!isConfirmed){
      console.log("Change the image cancelled! ")
      return;
    };
    setIsLoaded(true)
    
    const formData = new FormData();
    formData.append('image', formState.inputs.image.value);

    console.log('image:', formState.inputs.image.value)

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/${user.id}`, {
        method: 'PATCH',
        body: formData
      });

      if (!response.ok){
        throw new Error('Failed to update profile image')
      }

      const responseData = await response.json();
      console.log('admin image upload: ', responseData);
      updateUser ({ ...user, image: responseData.user.image });
    } catch (err) {
      console.log(err.message)
    }

  }

  if (isLoaded){
    return <div>Loading...</div>
  }

  return (
    <CourseModal show={show} onCancel={onCancel}>
      <h1>{Role} Profile</h1>
      <div className='adModal-profile-container'>
                     
        <div className='adModal_img_name_container'>
          <div className='adModal_img'>
              <ImageUpload                  
                id='image' 
                onInput={inputHandler} 
                image={`${process.env.REACT_APP_ASSET_URL}/${user.image}` }   
                onClick={uploadImageFile}
              />
          </div>

          <div className='adModal_name'>                         
            <h2>{firstName} <br/> {lastName}</h2>                                                                                                       
          </div>
        </div>
       
        <div className='adModal_email_pass'>

          <div className='adModal_email'>
            <div style={{marginRight: '10px'}}><MdAttachEmail /></div> 
            <div>Batsurenb30@gmail.com</div>                     
          </div>  

          <div className='adModal_phone'>
            <div  style={{marginRight: '10px'}}><FaPhoneAlt /></div>        
            <div> +1 (587)-973-0508</div>
          </div>
            
          <div className='adModal_address'>
            <div  style={{marginRight: '10px'}}> <FaAddressCard /> </div>    
            <div>550-130 New Brighton Way SE <br/> Calgary AB T2Z 1H8</div>       
          </div>
        </div>
      </div>             
    </CourseModal>     
  )
}
export default Admin;